module.exports = __webpack_public_path__ + "static/media/beer.eb00e72b.svg";